import { yupResolver } from '@hookform/resolvers/yup'
import { Box, Flex } from 'components/elements'
import { Modal } from 'components/modal'
import { MenuList } from 'components/sidebarLayout/Sidebar/SidebarMenu'
import { serviceLableAssessments } from 'configs/constants'
import { ErrorBox } from 'features/profile/components/EditProfileForm'
import { AddServiceFormData, AddServiceProp } from 'features/quote/components/type'
import { useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { Add_ServiceStatement, ValidationErrors } from 'utils/enum'
import { CustomRadioButton, ErrorCSS, Form, Label } from 'views/style'
import * as Yup from 'yup'
import { useAddService } from '../api/addService'
import { AxiosError } from 'axios'
import { errorMessage, formatServiceName } from 'utils/function'
import { ModalEnum } from 'features/incidents/components/enums'

const AddService = (props: AddServiceProp) => {
  const [submitError, setSubmitError] = useState('')
  const { openModal, setOpenModal, setNotification, currentServices, companyServices, planPrimaryService } = props
  const { mutate } = useAddService()

  const secondaryServices = companyServices?.filter(companyService => !currentServices?.includes(companyService.id) && companyService.id !== planPrimaryService)

  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm<AddServiceFormData>({
    resolver: yupResolver(Schema),
  })

  const onSubmit = (data: AddServiceFormData) => {
    const obj = {
      serviceId: data.service,
    }
    setSubmitError('')

    mutate(obj, {
      onSuccess: () => {
        setOpenModal({ label: '', isOpen: false })
        setNotification(ModalEnum.ADD_SERVICES)
        reset()
      },
      onError: error => {
        if (error instanceof AxiosError) {
          setSubmitError(errorMessage(error))
        }
      },
    })
  }
  return (
    <>
      <Modal
        active={openModal.label === ModalEnum.ADD_SERVICES && openModal.isOpen}
        hideModal={() => {
          setOpenModal({ label: '', isOpen: false })
        }}
        onAccept={handleSubmit(onSubmit)}
        title="Add Service"
        description={Add_ServiceStatement.ADD_SERVICE}
        isForm={true}
        children={
          <>
            <Form as="form">
              {!!submitError && <ErrorBox>{submitError}</ErrorBox>}

              <Box css={{ textAlign: 'left' }}>
                <Flex direction={'column'}>
                  <Box as="h4" css={{ paddingLeft: 0, fontWeight: '$bold' }}>
                    Add-ons
                  </Box>

                  {secondaryServices?.map((secondaryService, idx) => (
                    <MenuList key={idx}>
                      <Label key={secondaryService.name}>
                        <Controller
                          name="service"
                          control={control}
                          render={({ field }) => (
                            <CustomRadioButton
                              type="radio"
                              value={secondaryService.value}
                              checked={field.value === secondaryService.id}
                              onChange={() => {
                                field.onChange(field.value === secondaryService.id ? null : secondaryService.id)
                              }}
                              data-state={field.value === secondaryService.id ? 'checked' : 'unchecked'}
                            />
                          )}
                        />
                        <Box as="p" css={{ fontWeight: '$bold' }}>
                          {serviceLableAssessments[formatServiceName(secondaryService?.name ?? '')]} -&nbsp;
                          <Box as="span">{formatServiceName(secondaryService?.name ?? '')}</Box>
                        </Box>
                      </Label>
                    </MenuList>
                  ))}

                  {!!errors.service && <ErrorBox css={{ ...ErrorCSS, textAlign: 'left' }}>{errors.service.message}</ErrorBox>}
                </Flex>
              </Box>
            </Form>
          </>
        }
        acceptText={'Add Service'}
      />
    </>
  )
}
const Schema = Yup.object().shape({
  service: Yup.number().required(ValidationErrors.ADD_SERVICE),
})
export default AddService
